import React, { CSSProperties } from "react";

export interface SwitchProps {
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  labelOn?: string;
  labelOff?: string;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  size?: "sm" | "md";
  disabled?: boolean;
}
